import { BaseElement } from "@redotech/redo-model/content-builder/element-schema";
import { CSSProperties } from "react";

type BaseStyleProps = Pick<
  BaseElement,
  "backgroundColor" | "borderColor" | "borderWidth" | "cornerRadius" | "padding"
>;

export function getBaseElementStyles(element: BaseStyleProps): CSSProperties {
  const hasBorder = element.borderWidth && element.borderWidth > 0;

  return {
    ...(element.backgroundColor && {
      backgroundColor: element.backgroundColor,
    }),
    ...(hasBorder && {
      borderColor: element.borderColor,
      borderWidth: `${element.borderWidth}px`,
      borderStyle: "solid",
    }),
    ...(element.padding?.top !== undefined && {
      paddingTop: `${element.padding.top}px`,
    }),
    ...(element.padding?.right !== undefined && {
      paddingRight: `${element.padding.right}px`,
    }),
    ...(element.padding?.bottom !== undefined && {
      paddingBottom: `${element.padding.bottom}px`,
    }),
    ...(element.padding?.left !== undefined && {
      paddingLeft: `${element.padding.left}px`,
    }),
    ...(element.cornerRadius !== undefined && {
      borderRadius: `${element.cornerRadius}px`,
      overflow: "hidden",
    }),
  };
}
